export default "__VITE_ASSET__pfS398D___"